import { useMemo } from 'react';
import { useOptionsByPathQuery } from '../../../hooks/useOptionsByPathQuery.ts';
import { mapDataPartnerNames } from '../utils/mapDataPartnerNames.ts';

// account_list (unlike account) is readable by members; no account_uid, so admins get every partner
export const useDataPartnerNames = () => {
  const { data, loading, error } = useOptionsByPathQuery({
    variables: { path: 'segment.data_partner' },
  });

  const partnerNames = useMemo(() => (data ? mapDataPartnerNames(data.optionsByPath) : {}), [data]);

  return { partnerNames, loading, error };
};
